export default "__VITE_ASSET__BrY7NI8$__"